import React from "react";
import { TBadgeProps } from "../Badge";
import { Typography } from "../Typography";
import * as S from "./styled";

const LOCALE = "en-US";

const getDisplayableValue = (value: number | string | undefined): string | undefined => {
    if (typeof value !== "number") {
        return value;
    }

    return value > 0 ? value.toLocaleString(LOCALE) : undefined;
};

type Props = {
    active: boolean;
    disabled?: boolean;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    label: string;
    value: number | string | undefined;
    badgeProps: Omit<TBadgeProps, "text"> | undefined;
};

export const Facet = ({ active, disabled, onClick, label, value, badgeProps = {} }: Props) => {
    const displayableValue: string | undefined = getDisplayableValue(value);

    return (
        <S.Facet
            data-active={active}
            data-default={!badgeProps.variant || badgeProps.variant === "default"}
            onClick={onClick}
            disabled={disabled}
        >
            <Typography variant="label-small-medium">{label}</Typography>
            {displayableValue ? <S.CountBadge icon text={displayableValue} {...badgeProps} /> : null}
        </S.Facet>
    );
};
